<script>
import moment from 'moment'
import {getPublicLinkS3} from '../../../../domain/grv/services'

export default {
  name: 'ListaArquivosNotificacoesGrv',
  props: {
    lista: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false
    }
  },
  methods: {
    formatarData (date, format = 'DD/MM/YYYY HH:mm') {
      const {date: dateClone} = JSON.parse(JSON.stringify(date))
      return moment(dateClone).format(format)
    },
    download ({id}) {
      this.$loaderOverlay.open()
      getPublicLinkS3(id)
        .then(response => {
          const link = document.createElement('a')
          link.href = `${process.env.API_URL}${response.data}`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Ocorreu um erro ao acessar o arquivo , tente novamente')
          this.$loaderOverlay.hide()
          console.log(error)
        })
    }
  }
}
</script>

<template>
  <div class="table-responsive" v-if="lista.length">
    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
      <thead>
      <tr>
        <th>Cadastrado em</th>
        <th>Arquivo</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="loading">
        <td colspan="6">Carregando...</td>
      </tr>
      <tr v-else v-for="item in lista">
        <td scope="row" role="button" tabindex="0">
          {{formatarData(item.storageCreatedAt)}}
        </td>
        <td scope="row" role="button" tabindex="0">
          <button class="btn btn-link" @click.stop.prevent="download(item)">
            <i class="fa fa-download"></i> Visualizar arquivo
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// ListaArquivosNotificacoesGrv.vue?7cd896ac